/*
* 菜单组件
* 说明：按模块分类显示菜单，不展开与折叠
* zxw
* 创建时间：2026-01-28
*/


import {
    Space,
    Button,
    Typography,
    theme,
} from 'antd';

import CNF from '../incs/Config';

const { Text } = Typography;
const YMenu = (props) => {
    const {
        token: {
            colorTextBase,
            colorBgActive,
        },
    } = theme.useToken();

    return <Space>
        {
            CNF.menuItems.map((item, index) => {
                if (props.btnLists.indexOf(item.ptn) < 0) return null;
                return <div key={index}>
                    <p><Text>{item.name}</Text></p>
                    {
                        item.submenu.map((subitem, subindex) => {
                            if (props.btnLists.indexOf(subitem.ptn) < 0) return null;
                            return <Button
                                className='active-button'
                                key={subindex}
                                color='default'
                                variant='text'
                                block
                                style={{
                                    textAlign: 'left',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    marginBottom: '5px',
                                    paddingLeft: '4px',
                                    color: colorTextBase,
                                    background: props.uri.startsWith(subitem.uri) ? colorBgActive : '',

                                }}
                                onClick={() => {
                                    props.setUri(subitem.uri);
                                }}
                            >
                                {subitem.icon}{subitem.name}
                            </Button>
                        })
                    }
                </div>
            })
        }
    </Space>
}

export default YMenu;